import React from 'react';
import { ModalBodyWrapper } from '../../Popup/popup.styles';

const PopupBody = ({ children, padding }) => {
  return <ModalBodyWrapper padding={padding}>{children}</ModalBodyWrapper>;
};

export default PopupBody;
